import React, { Component, PropTypes } from 'react';
import { StoreOverviewActions } from 'actions';
import * as SvgIcons from 'components/Material/SvgIcons';
import { Toolbar, ToolbarGroup, ToolbarButton } from 'components/Toolbar';

class StoreLayoutEditorToolbar extends Component {
  static propTypes = {
    canUndo: PropTypes.bool
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  editMode = () => {
    StoreOverviewActions.editMode();
  };

  listMode = () => {
    this.save();
    StoreOverviewActions.listMode();
  };

  save = () => {
    StoreOverviewActions.update();
  };

  publish = () => {
    StoreOverviewActions.publish();
  };

  undo = () => {
    StoreOverviewActions.undo();
  };

  discard = () => {
    StoreOverviewActions.discard();
  };

  render() {
    const { canUndo, ...other } = this.props;
    const { getIntlMessage } = this.context;
    return (
      <Toolbar center key="edit" {...other}>
        <ToolbarGroup>
          <ToolbarButton
            onTouchTap={this.listMode}
            tooltip={getIntlMessage('menu.Back')}
          >
            <SvgIcons.NavigationArrowBack />
          </ToolbarButton>
        </ToolbarGroup>
        <ToolbarGroup right>
          <ToolbarButton
            disabled={!canUndo}
            tooltip={getIntlMessage('storeBuilder.undo')}
            onTouchTap={this.undo}
          >
            <SvgIcons.ContentUndo />
          </ToolbarButton>
          <ToolbarButton
            tooltip={getIntlMessage('storeBuilder.save')}
            onTouchTap={this.save}
          >
            <SvgIcons.ContentSave />
          </ToolbarButton>
          <ToolbarButton
            tooltip={getIntlMessage('storeBuilder.discard')}
            onTouchTap={this.discard}
          >
            <SvgIcons.ActionDelete />
          </ToolbarButton>
          <ToolbarButton
            tooltip={getIntlMessage('storeBuilder.publish')}
            onTouchTap={this.publish}
          >
            <SvgIcons.EditorPublish />
          </ToolbarButton>
        </ToolbarGroup>
      </Toolbar>
    );
  }
}

export default StoreLayoutEditorToolbar;



// WEBPACK FOOTER //
// ./src/js/components/Store/StoreLayoutEditorToolbar.js